<section class="tag-catalog-card">
  <header class="tag-catalog-header">
    <div class="tag-catalog-heading">
      <h2>{{ heading }}</h2>
      <p>{{ description }}</p>
    </div>
    <app-gpd-button
      *ngIf="!editing"
      i18n-text="@@add"
      text="Add"
      icon="add"
      [height]="36"
      (onClick)="startCreate()"
    ></app-gpd-button>
  </header>

  <!-- Create / rename form (same inline pattern for both) -->
  <dx-validation-group *ngIf="editing" #formGroup>
    <div class="tag-form">
      <label class="tag-form-field">
        <span class="tag-form-label"><ng-container i18n="@@name">Name</ng-container><span class="required">*</span></span>
        <dx-text-box
          #nameBox
          class="gpd-input tag-form-input"
          [placeholder]="namePlaceholder"
          [maxLength]="50"
          [(value)]="editing.name"
          valueChangeEvent="keyup"
          (onEnterKey)="confirm()"
        >
          <dx-validator>
            <dxi-validation-rule type="required" i18n-message="@@required" message="Required"></dxi-validation-rule>
            <dxi-validation-rule
              type="custom"
              [validationCallback]="isNameUnique"
              [message]="duplicateMessage"
            ></dxi-validation-rule>
          </dx-validator>
        </dx-text-box>
      </label>
      <div class="gpd-button-group tag-form-actions">
        <app-gpd-button i18n-text="@@cancel" text="Cancel" icon="cancel" type="secondary" (onClick)="cancel()"></app-gpd-button>
        <app-gpd-button i18n-text="@@confirm" text="Confirm" icon="tick" (onClick)="confirm()"></app-gpd-button>
      </div>
    </div>
  </dx-validation-group>

  <div class="tag-catalog-table" *ngIf="!editing && tags.length > 0">
    <dx-text-box
      class="gpd-input tag-search"
      width="350px"
      mode="search"
      i18n-placeholder="@@search"
      placeholder="Search"
      valueChangeEvent="keyup"
      (onValueChanged)="search($event.value)"
    ></dx-text-box>
    <dx-data-grid
      #tagsGrid
      class="gpd-datagrid tag-catalog-grid"
      [dataSource]="tags"
      keyExpr="id"
      [showBorders]="true"
      [hoverStateEnabled]="true"
      [width]="'100%'"
    >
      <dxo-search-panel [visible]="false"></dxo-search-panel>
      <dxi-column dataField="name" i18n-caption="@@name" caption="Name" sortOrder="asc"></dxi-column>
      <dxi-column [width]="96" [allowSorting]="false" cellTemplate="actionsTemplate"></dxi-column>
      <div *dxTemplate="let cell of 'actionsTemplate'" class="gpd-table-actions">
        <app-svg-icon
          icon="edit"
          color="var(--color-primary)"
          [size]="20"
          [strokeWidth]="1.5"
          class="tag-action"
          [class.locked]="cell.data.locked"
          i18n-title="@@edit"
          title="Edit"
          (click)="!cell.data.locked && startEdit(cell.data)"
        ></app-svg-icon>
        <app-svg-icon
          icon="delete"
          color="var(--color-red-500)"
          [size]="20"
          [strokeWidth]="1.5"
          class="tag-action"
          [class.locked]="cell.data.locked"
          i18n-title="@@delete"
          title="Delete"
          (click)="!cell.data.locked && confirmDelete(cell.data)"
        ></app-svg-icon>
      </div>
    </dx-data-grid>
  </div>

  <p class="tag-catalog-empty" *ngIf="!editing && loaded && tags.length === 0">{{ emptyText }}</p>
</section>
